import { CountriesWithPrices } from './CountriesWithPrices';

export default CountriesWithPrices;
